// extracted by mini-css-extract-plugin
module.exports = {"page":"TestPage_page__uEre9 page_page__31uF2"};